
import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section id="contact" className="relative py-32 overflow-hidden">
      {/* Gradient Background with Pattern */}
      <div className="absolute inset-0 bg-gradient-to-r from-purple-600 via-pink-600 to-purple-700">
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage:
              'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {/* Heading */}
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Ready to Transform<br />Your Business?
        </h2>

        {/* Subheading */}
        <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto">
          Join 5,000+ businesses already using AI receptionist to scale their
          operations and delight their customers. Book your spot today.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/start-free-trial"
            className="px-10 py-5 bg-white text-purple-700 font-semibold rounded-full hover:shadow-2xl transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer text-lg"
          >
            Start Free Trial
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>

          <Link
            to="/demo"
            className="px-10 py-5 border-2 border-white text-white font-semibold rounded-full hover:bg-white hover:text-purple-600 transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer text-lg"
          >
            <i className="ri-play-circle-line text-xl"></i>
            Watch Demo
          </Link>
        </div>

        <p className="text-sm text-white/70 mt-8">
          Free consultation &bull; No credit card required &bull; Cancel anytime
        </p>
      </div>
    </section>
  );
}
